module.exports = __webpack_public_path__ + "img/ico_trophy.aaebd304.png";